import { useState, useMemo, useEffect } from "react";
import { authService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { RequestStatus } from "../../shared";

export type UsePasswordResetRequest = (email: string, isRepeatedLetter?: boolean) => Promise<void>;

export function UsePasswordResetRequest(): [RequestStatus, UsePasswordResetRequest] {
  const [status, setStatus] = useState(RequestStatus.None);
  const passwordResetRequest: UsePasswordResetRequest = useMemo(
    () => async (email, isRepeatedLetter) => {
      setStatus(RequestStatus.Pending);
      try {
        await authService.passwordResetRequest(email, isRepeatedLetter);
      } catch (err) {}
    },
    [],
  );

  useEffect(() => {
    const sub = authService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(sub);
  }, []);

  return [status, passwordResetRequest];
}
